// src/components/home/EventsSection/EventsSection.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarCheck,
    faStar,
    faUsers,
    faBell
} from '@fortawesome/free-solid-svg-icons';
import './EventsSection.css';

const EventsSection = () => {
    const highlights = [
        'Magic shows & performances',
        'Arts, crafts & pottery',
        'Dance & movement',
        'Science experiments',
        'Games & outdoor fun'
    ];

    return (
        <section className="events" id="events">
            <div className="events__container">
                {/* Header */}
                <div className="events__header">
                    <span className="events__label">Past Event</span>
                    <h2 className="events__title">Summer Fiesta 2025</h2>
                    <p className="events__subtitle">
                        A memorable summer adventure filled with learning,
                        creativity, and fun.
                    </p>
                </div>

                {/* Event Card */}
                <div className="events__card">
                    <div className="events__card-badge">
                        <FontAwesomeIcon icon={faCalendarCheck} />
                        <span>Completed</span>
                    </div>

                    <div className="events__details">
                        <div className="events__detail">
                            <span className="events__detail-label">When</span>
                            <span className="events__detail-value">April - May 2025</span>
                        </div>
                        <div className="events__detail">
                            <span className="events__detail-label">Where</span>
                            <span className="events__detail-value">Little Elly Kudlu</span>
                        </div>
                        <div className="events__detail">
                            <span className="events__detail-label">Ages</span>
                            <span className="events__detail-value">4 - 10 years</span>
                        </div>
                    </div>

                    <div className="events__highlights">
                        <h3>Highlights</h3>
                        <div className="events__highlights-grid">
                            {highlights.map((item, index) => (
                                <span key={index} className="events__highlight">
                                    <FontAwesomeIcon icon={faStar} />
                                    {item}
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="events__stats">
                        <div className="events__stat">
                            <FontAwesomeIcon icon={faUsers} />
                            <div>
                                <span className="events__stat-value">35+</span>
                                <span className="events__stat-label">Children</span>
                            </div>
                        </div>
                        <div className="events__stat">
                            <FontAwesomeIcon icon={faStar} />
                            <div>
                                <span className="events__stat-value">Great</span>
                                <span className="events__stat-label">Feedback</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Future Events Banner */}
                <div className="events__upcoming">
                    <FontAwesomeIcon icon={faBell} className="events__upcoming-icon" />
                    <div>
                        <h3>Stay Tuned</h3>
                        <p>Follow us on social media to be the first to know about upcoming events.</p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default EventsSection;
